/**
 * Shared types for discharge letter templates.
 */

/** Configuration for building a discharge letter. */
export interface DischargeLetterConfig {
  id: string
  label: string
  /** Optional heading above the procedure line. */
  title?: string
  /** Procedure description text. When `procedureField` is true, this is the prefix before the fill-in field. */
  procedureText: (patientName: string) => string
  /** Whether to render a fill-in field after the procedure text for the procedure name. */
  procedureField?: boolean
}

/** Fields for discharge letter forms. */
export interface DischargeLetterFields {
  /** Only used when the config has `procedureField: true`. */
  procedureName: string
  painMedication: string
  woundCheckDate1: string
  woundCheckDate2: string
}

export const defaultDischargeLetterFields: DischargeLetterFields = {
  procedureName: '',
  painMedication: '',
  woundCheckDate1: '',
  woundCheckDate2: '',
}
